import React from 'react';
import Form from 'react-bootstrap/Form';
import omit from 'lodash/omit';
import { Field, useFormikContext } from 'formik';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import useSWR from 'swr';
import { fetcher } from '../../common/api/fetcher';
import { ProductsDrinksMenuSelector } from './ProductsDrinksMenuSelector';

export const ProductsDrinksMenuList = () => {
  const { values, setFieldValue } = useFormikContext();
  const drinksMenuIds = values?.soldAt ? Object.keys(values?.soldAt) : [];
  const { data } = useSWR(
    drinksMenuIds
      ? `/portal/products/drinks-menus?id=${drinksMenuIds.join(',')}&limit=500`
      : null,
    fetcher
  );

  return (
    <div>
      {!drinksMenuIds.length ? (
        <Form.Control
          readOnly={true}
          type="text"
          plaintext
          defaultValue="None"
        />
      ) : (
        <Table striped bordered>
          <thead>
            <tr>
              <th>Name</th>
              <th>Price</th>
              <th>Available on Draught?</th>
              <th width="15" />
            </tr>
          </thead>
          <tbody>
            {data?.map((drinksMenu) => {
              return (
                <tr key={drinksMenu.id}>
                  <td>
                    {drinksMenu.name} <br />
                    <small>
                      <b>{drinksMenu.company.name}</b>
                    </small>
                  </td>
                  <td>
                    <Field name={`soldAt.${drinksMenu.id}.price`}>
                      {({ field, meta }) => (
                        <Form.Control
                          as="input"
                          type="number"
                          step="any"
                          style={{ width: '110px' }}
                          {...field}
                          isInvalid={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </td>
                  <td>
                    {values?.availableOnDraught === 'true' && (
                      <Field
                        type="checkbox"
                        name={`soldAt.${drinksMenu.id}.servedOnDraught`}
                      >
                        {({ field }) => (
                          <Form.Control as="input" type="checkbox" {...field} />
                        )}
                      </Field>
                    )}
                  </td>
                  <td width="15">
                    <Button
                      variant="outline-danger"
                      type="button"
                      className="border-orange-br bg-orange-br"
                      onClick={() => {
                        setFieldValue(
                          'soldAt',
                          omit(values?.soldAt, [drinksMenu.id])
                        );
                      }}
                    >
                      X
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
      <ProductsDrinksMenuSelector
        onSelect={(drinksMenu) => {
          setFieldValue('soldAt', { ...values?.soldAt, [drinksMenu.id]: {} });
        }}
      />
    </div>
  );
};
